export default "__VITE_ASSET__C4GzZ1Jb__"